import { toAbsoluteSiteUrl } from "./siteUrl";
import { councilSlugToShortCode, getCouncilConfig, isLegacyCouncil } from "./councils";

export function buildPlanningApplicationPath(reference, council) {
  const raw = typeof reference === "string" ? reference : String(reference || "");
  const segments = raw
    .split("/")
    .map((segment) => segment.trim())
    .filter(Boolean)
    .map((segment) => encodeURIComponent(segment));

  if (segments.length === 0) return "/planning-updates";
  const councilConfig = getCouncilConfig(council);
  if (councilConfig && !isLegacyCouncil(councilConfig.slug)) {
    return `/planning-updates/${councilSlugToShortCode(councilConfig.slug)}/${segments.join("/")}`;
  }
  return `/planning-application/${segments.join("/")}`;
}

export function buildPlanningApplicationUrl(reference, council) {
  return toAbsoluteSiteUrl(buildPlanningApplicationPath(reference, council));
}
